import { ButtonType, ButtonWidget } from '@tableau/widgets';
import React from 'react';

import { L10n } from '~src/commonInfra/L10n/L10n';
import { imgPath } from '~src/commonInfra/utils/ImgUrl';

import { Messages } from '../../codegen/Localize';
import { IServerUser } from '../../userManagement/users/serverApi/types/IServerUser';
import { UserSettingsStyle } from '../../userSettings/styles/UserSettingsStyle';
import { showDeletePersonalAccessTokenActionDialog } from '../actions/DeletePersonalAccessTokenAction';
import { IPersonalAccessToken } from '../serverApi/types/personalAccess/IPersonalAccessToken';

export interface ListPersonalAccessTokensSectionProps {
  serverUser: IServerUser;
  personalAccessTokens: IPersonalAccessToken[];
  refreshTokenList: (userId: string) => void;
}

export function ListPersonalAccessTokensSection(props: ListPersonalAccessTokensSectionProps) {

  async function deletePersonalAccessToken(token: IPersonalAccessToken) {
    await showDeletePersonalAccessTokenActionDialog(token, props.serverUser.id);
    props.refreshTokenList(props.serverUser.id);
  }

  if (props.personalAccessTokens.length === 0) {
    return (
      <div data-tb-test-id='empty-pat-list'> {Messages.personalAccessTokenNoTokens()} </div>
    );
  }
  return (
    <div className="tb-user-settings-item-table">
      <table className="tb-static-grid-table tb-static-grid-table-settings-width">
        <tbody>
          <tr>
            <th className={UserSettingsStyle.tableHeaderLine}>
              <span className="tb-data-grid-header-text">
                {Messages.personalAccessTokenNameColumnTitle()}
              </span>
            </th>
            <th className={UserSettingsStyle.tableHeaderLine}>
              <span className="tb-data-grid-header-text">
                {Messages.personalAccessTokenExpirationColumnTitle()}
              </span>
            </th>
            <th className={UserSettingsStyle.tableHeaderLine}>
              <span className="tb-data-grid-header-text" />
            </th>
          </tr>
          {props.personalAccessTokens.map((personalAccessToken, index) => {
            return (
              <tr key={index} data-tb-test-id='pat-list-item'>
                <td className={UserSettingsStyle.tableMultilineWithSeparatorRow}
                  data-tb-test-id={'pat-details-for-' + personalAccessToken.clientId}>
                  <div className="tb-data-grid-cell-text">
                    <span className={UserSettingsStyle.itemTableName} title={personalAccessToken.clientId}>
                      {personalAccessToken.clientId}
                    </span>
                  </div>
                </td>
                <td className={UserSettingsStyle.tableMultilineWithSeparatorRow}
                  data-tb-test-id={'pat-expiry-details-for-' + personalAccessToken.clientId}>
                  <div className="tb-data-grid-cell-text">
                    <span className={UserSettingsStyle.itemTableName} title={personalAccessToken.expiresAt}>
                      {L10n.localizedDate(personalAccessToken.expiresAt)}
                    </span>
                  </div>
                </td>
                <td className={UserSettingsStyle.tableMultilineWithSeparatorRow}>
                  <ButtonWidget
                    title={Messages.personalAccessTokenRevoke()}
                    buttonType={ButtonType.LowEmphasis}
                    style={{ float: 'right' }}
                    testId={'revoke-pat-button-' + personalAccessToken.clientId}
                    onClick={() => deletePersonalAccessToken(personalAccessToken)}
                  >
                    <img src={imgPath('trash_14px_small.svg')} alt="" /><span>{' ' + Messages.personalAccessTokenRevoke()}</span>
                  </ButtonWidget>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
